import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Service to provide API configuration for all services.
 * This centralizes the API base URL and tenant configuration.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiConfigService {
  private tenantId: string = '';

  constructor() {
    // Initialize tenant from localStorage if available (persists across refreshes)
    if (typeof localStorage !== 'undefined') {
      this.tenantId = localStorage.getItem('tenantId') || '';
    }
  }

  /**
   * Get the API base URL
   */
  getApiBaseUrl(): string {
    return environment.apiBaseUrl;
  }

  /**
   * Get the full API URL for a given endpoint
   * @param endpoint The API endpoint (e.g., '/agent', '/integration')
   */
  getApiUrl(endpoint: string): string {
    return `${environment.apiBaseUrl}/${this.tenantId}${endpoint}`;
  }

  /**
   * Set the current tenant ID
   */
  setTenantId(tenantId: string): void {
    this.tenantId = tenantId;
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('tenantId', tenantId);
    }
  }

  /**
   * Get the current tenant ID
   */
  getTenantId(): string {
    if (!this.tenantId && typeof localStorage !== 'undefined') {
      this.tenantId = localStorage.getItem('tenantId') || '';
    }
    return this.tenantId;
  }

  /**
   * Clear the tenant ID
   */
  clearTenantId(): void {
    this.tenantId = '';
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('tenantId');
    }
  }
}
